import { Briefcase, Mic2, Sparkles, Target } from "lucide-react";

export const SERVICES = [
  {
    slug: "coaching",
    title: "Private Coaching",
    shortTitle: "Coaching",
    eyebrow: "1:1 Guidance",
    icon: Sparkles,
    summary:
      "One-on-one coaching for clarity, mindset mastery, and purpose-aligned growth.",
    description:
      "Private coaching with Wisdom Peters is designed for leaders, entrepreneurs, and seekers who want practical transformation. Sessions blend psychology, faith, and strategy so you leave with clarity and actionable next steps.",
    outcomes: [
      "Clear personal and professional priorities",
      "Mindset tools for decision-making under pressure",
      "A focused action plan for your next season",
      "Accountability between sessions",
    ],
    whoFor: [
      "Executives and founders",
      "Ministry and marketplace leaders",
      "Professionals navigating transition",
    ],
    packages: [
      {
        id: "coaching-single",
        name: "Single Strategy Session",
        duration: "60 minutes",
        priceLabel: "From £150",
        priceGbp: 150,
      },
      {
        id: "coaching-vip",
        name: "VIP Coaching Intensive",
        duration: "90 minutes",
        priceLabel: "From £275",
        priceGbp: 275,
      },
      {
        id: "coaching-month",
        name: "4-Week Coaching Track",
        duration: "4 × 60 minutes",
        priceLabel: "From £520",
        priceGbp: 520,
      },
    ],
    image: "/pl 3.jpeg",
  },
  {
    slug: "consulting",
    title: "Business & Leadership Consulting",
    shortTitle: "Consulting",
    eyebrow: "Strategic Advisory",
    icon: Briefcase,
    summary:
      "High-level consulting for visionaries and organisations navigating growth and transition.",
    description:
      "Consulting engagements help founders, executives, and organisations develop scalable models, ethical leadership, and purpose-aligned profitability. Ideal for brand repositioning, leadership transitions, and strategic clarity.",
    outcomes: [
      "Strategic diagnosis of current challenges",
      "Practical growth and leadership recommendations",
      "Purpose-aligned business / ministry models",
      "Clear roadmap for the next 90 days",
    ],
    whoFor: [
      "Startup founders and CEOs",
      "Faith-driven entrepreneurs",
      "Organisations in transition",
    ],
    packages: [
      {
        id: "consulting-discovery",
        name: "Discovery Call",
        duration: "45 minutes",
        priceLabel: "From £120",
        priceGbp: 120,
      },
      {
        id: "consulting-strategy",
        name: "Strategy Consultation",
        duration: "90 minutes",
        priceLabel: "From £350",
        priceGbp: 350,
      },
      {
        id: "consulting-advisory",
        name: "Advisory Retainer (monthly)",
        duration: "Ongoing",
        priceLabel: "Custom quote",
        priceGbp: null,
      },
    ],
    image: "/pl 4.jpeg",
  },
  {
    slug: "mentorship",
    title: "Custom Mentorship Tracks",
    shortTitle: "Mentorship",
    eyebrow: "Long-term Development",
    icon: Target,
    summary:
      "Bespoke mentorship pathways for ministers, coaches, CEOs, and high achievers.",
    description:
      "Mentorship tracks are structured over weeks or months to raise capacity, character, and competence. Pathways are tailored for ministers, coaches, and marketplace leaders who want sustained growth — not a one-off conversation.",
    outcomes: [
      "A personalised development pathway",
      "Regular mentoring touchpoints",
      "Leadership and emotional intelligence growth",
      "Support through real-world decisions",
    ],
    whoFor: [
      "Ministers and ministry teams",
      "Coaches and consultants",
      "High achievers seeking accountability",
    ],
    packages: [
      {
        id: "mentorship-intro",
        name: "Mentorship Intro Session",
        duration: "60 minutes",
        priceLabel: "From £150",
        priceGbp: 150,
      },
      {
        id: "mentorship-8week",
        name: "8-Week Mentorship Track",
        duration: "8 weeks",
        priceLabel: "From £960",
        priceGbp: 960,
      },
      {
        id: "mentorship-bespoke",
        name: "Bespoke Mentorship Programme",
        duration: "Custom",
        priceLabel: "Custom quote",
        priceGbp: null,
      },
    ],
    image: "/pl 2.jpeg",
  },
  {
    slug: "speaking",
    title: "Speaking Engagements",
    shortTitle: "Speaking",
    eyebrow: "Conferences & Events",
    icon: Mic2,
    summary:
      "Keynotes and teaching for conferences, leadership summits, churches, and retreats.",
    description:
      "Wisdom Peters speaks on spiritual intelligence, mental wellness, high-performance habits, kingdom economics, and holistic success. Invite him for conferences, leadership summits, church gatherings, and retreats.",
    outcomes: [
      "Spiritually grounded, practical teaching",
      "Audience engagement and prophetic clarity",
      "Content tailored to your event theme",
      "Optional book table / resource partnership",
    ],
    whoFor: [
      "Conference and summit organisers",
      "Churches and ministry networks",
      "Corporate and marketplace events",
    ],
    packages: [
      {
        id: "speaking-keynote",
        name: "Keynote Address",
        duration: "45–60 minutes",
        priceLabel: "Custom quote",
        priceGbp: null,
      },
      {
        id: "speaking-workshop",
        name: "Workshop / Masterclass",
        duration: "Half day",
        priceLabel: "Custom quote",
        priceGbp: null,
      },
      {
        id: "speaking-retreat",
        name: "Retreat / Multi-session",
        duration: "Custom",
        priceLabel: "Custom quote",
        priceGbp: null,
      },
    ],
    image: "/pl 4.jpeg",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((service) => service.slug === slug);

export const TIME_SLOTS = [
  "09:00",
  "10:30",
  "12:00",
  "14:00",
  "15:30",
  "17:00",
];

/** Next N weekdays (Mon–Fri) from tomorrow, UK-facing schedule */
export function getAvailableDates(count = 20) {
  const dates = [];
  const cursor = new Date();
  cursor.setHours(0, 0, 0, 0);
  cursor.setDate(cursor.getDate() + 1);

  while (dates.length < count) {
    const day = cursor.getDay();
    if (day !== 0 && day !== 6) {
      dates.push(new Date(cursor));
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return dates;
}

export function formatBookingDate(date) {
  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
